export default __webpack_public_path__ + "static/media/twitter.a910fc40.svg";